import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-advt-outstanding-report',
  standalone: false,
  templateUrl: './advt-outstanding-report.component.html',
  styleUrl: './advt-outstanding-report.component.scss'
})
export class AdvtOutstandingReportComponent {
  currentDate: Date;


  
    constructor(
      private dialogRef: MatDialogRef<AdvtOutstandingReportComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService,
      private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
    ) {
     
    }

    

  reportType:any
  startDate :any
  endDate :any
  repName :any
  offRepName:any
  advtName :any
  issueDates:any
  issueDates1:any
  OutstandingInDetailFormBeans:any

  OutStandingIDTotal: number = 0;
  OutStandingIDNetAmtTotal: number = 0;
  OutStandingIDUnPaidTotal: number = 0;
  ngOnInit(): void {

    this.currentDate = new Date();
    debugger
    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
    this.repName = this.data['repName'];
    this.offRepName = this.data['offRepName'];
    this.advtName = this.data['name'];
    this.issueDates = this.data.issueDates;
    this.issueDates1 = this.data['issue_date'];

    const req: any = {
      "rep_name":  this.repName,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "advt_name": this.data['name'],
      // // "issue_name" : this.advtName,
      // "issue_date": this.issueDates
      "issue_name": "",
      "issue_date": this.issueDates1


    }

    this.service.getAdvtOutstanding(req).subscribe((data: any) => {
      console.log("outstanding 3", data)
      this.OutstandingInDetailFormBeans = data as any;

      this.OutStandingIDTotal = 0;
      this.OutStandingIDNetAmtTotal = 0;
      this.OutStandingIDUnPaidTotal = 0;

      for (let data of this.OutstandingInDetailFormBeans) {


        for (let data1 of data.rep_data) {

          this.OutStandingIDTotal += parseFloat(data1.advt_amt_total) || 0;
          this.OutStandingIDNetAmtTotal += parseFloat(data1.net_amt_total) || 0;
          this.OutStandingIDUnPaidTotal += parseFloat(data1.unpaid_amt_total) || 0;
        }
      }

      console.log("this.OutStandingIDTotal", this.OutStandingIDTotal);
      console.log("this.OutStandingIDNetAmtTotal", this.OutStandingIDNetAmtTotal);
      console.log("this.OutStandingIDUnPaidTotal", this.OutStandingIDUnPaidTotal);
    });


  }


  exportExcel(fileName): void {
  console.log('Export function called with fileName:', fileName);
  
  let element = document.getElementById('print-section');
  console.log('Element found:', element);
  
  if (!element) {
    console.error('Element with ID "print-section" not found in DOM');
    return;
  }
  
  try {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    console.log('Worksheet created:', ws);
    
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
    XLSX.writeFile(wb, fileName + '.xlsx');
    console.log('File should be downloaded');
  } catch (error) {
    console.error('Error during export:', error);
  }
}
}
